import { Action } from 'redux-actions';
import { CheckinOrderFragment } from '@websky/graphql';
import { SET_CHECKIN_ORDER } from './actions';
import { CheckinSegmentFragment } from '@websky/graphql';

const isUpgradeSegment = (segment: CheckinSegmentFragment): boolean =>
	segment?.checkinInfo?.checkInSubStatus === 'Upgrade';

const withoutUpgradeSegments = (order: CheckinOrderFragment): CheckinOrderFragment => {
	if (!order?.segments?.some(isUpgradeSegment)) {
		return order;
	}

	return {
		...order,
		segments: order.segments.filter(segment => !isUpgradeSegment(segment))
	};
};

export const orderReducer = (
	state: CheckinOrderFragment = null,
	action: Action<CheckinOrderFragment>
): CheckinOrderFragment => {
	if (action.type === SET_CHECKIN_ORDER) {
		return withoutUpgradeSegments(action.payload);
	}

	return state;
};
